var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDriversTrashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.97,
    height: 16.634,
    viewBox: "0 0 14.97 16.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.332,5.5h2.5V4.663A1.663,1.663,0,0,1,9.49,3h4.99a1.663,1.663,0,0,1,1.663,1.663V5.5h2.5a.832.832,0,0,1,0,1.663h-.832V17.97a1.663,1.663,0,0,1-1.663,1.663H7.827A1.663,1.663,0,0,1,6.163,17.97V7.158H5.332a.832.832,0,0,1,0-1.663Zm2.5,1.663V17.97h8.317V7.158ZM9.49,5.5h4.99V4.663H9.49Zm0,3.327h1.663v7.485H9.49Zm3.327,0H14.48v7.485H12.817Z",
    transform: "translate(-4.5 -3)",
    fill: "#adb5bd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriversTrashIcon);
export default __webpack_public_path__ + "static/media/drivers-trash-icon.d0f0c943.svg";
export { ForwardRef as ReactComponent };